import AtFaultInsuranceItem from "./AtFaultInsuranceItem";

export default function AtFaultInsurances({classes, activeCase, isProcessed}) {
    return <div className={classes.group}>
        {activeCase.police_report?.moonbird_data?.insurances?.liability?.map((item, index) => (
            <AtFaultInsuranceItem key={index} classes={classes} activeCase={activeCase} item={item} index={index} isProcessed={isProcessed}/>
        ))}

{/* <AtFaultInsuranceItem key={0} classes={classes} activeCase={activeCase} item={activeCase.police_report?.moonbird_data?.insurances?.liability[0]} index={0}/> */}
    </div>
}